"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PackageTree", {
    enumerable: true,
    get: function() {
        return PackageTree;
    }
});
const _execa = /*#__PURE__*/ _interop_require_default(require("execa"));
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _micromatch = /*#__PURE__*/ _interop_require_default(require("micromatch"));
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _tree = /*#__PURE__*/ new WeakMap(), _packageFiles = /*#__PURE__*/ new WeakMap(), _memoizedPackageFiles = /*#__PURE__*/ new WeakMap();
class PackageTree {
    reset() {
        // reset the internal state
        _class_private_field_set(this, _tree, {
            children: {},
            isPackage: true
        });
        _class_private_field_set(this, _packageFiles, {});
        _class_private_field_set(this, _memoizedPackageFiles, {});
    }
    async initialize() {
        const { root, includeUntracked, packageInfos } = this.options;
        this.reset();
        // Generate path tree of all packages in workspace (scale: ~2000 * ~3)
        for (const info of Object.values(packageInfos)){
            const packagePath = _path.default.dirname(info.packageJsonPath);
            const pathParts = _path.default.relative(root, packagePath).split(/[\\/]/);
            let currentNode = _class_private_field_get(this, _tree);
            for (const part of pathParts){
                // initialize the children if not already done
                currentNode.children[part] = currentNode.children[part] || {
                    children: {},
                    isPackage: false
                };
                currentNode = currentNode.children[part];
            }
            currentNode.isPackage = true;
        }
        // Get all files in the workspace (scale: ~2000) according to git
        const lsFilesResults = await (0, _execa.default)("git", [
            "ls-files",
            "-z"
        ], {
            cwd: root
        });
        if (lsFilesResults.exitCode === 0) {
            const files = lsFilesResults.stdout.split("\0").filter((f)=>Boolean(f) && _fs.default.existsSync(_path.default.join(root, f)));
            this.addToPackageTree(files);
        }
        if (includeUntracked) {
            // Also get all untracked files in the workspace according to git
            const lsOtherResults = await (0, _execa.default)("git", [
                "ls-files",
                "-o",
                "-z",
                "--exclude-standard"
            ], {
                cwd: root
            });
            if (lsOtherResults.exitCode === 0) {
                const files = lsOtherResults.stdout.split("\0").filter(Boolean);
                this.addToPackageTree(files);
            }
        }
    }
    async addToPackageTree(filePaths) {
        // key: path/to/package (packageRoot), value: array of a tuple of [file, hash]
        const packageFiles = _class_private_field_get(this, _packageFiles);
        for (const entry of filePaths){
            const pathParts = entry.split(/[\\/]/);
            let node = _class_private_field_get(this, _tree);
            const pathPartsBuffer = [];
            let packagePathParts = [];
            for (const part of pathParts){
                if (node.children[part]) {
                    node = node.children[part];
                    pathPartsBuffer.push(part);
                    if (node.isPackage) {
                        packagePathParts = [
                            ...pathPartsBuffer
                        ];
                    }
                } else {
                    break;
                }
            }
            const packageRoot = packagePathParts.join("/");
            packageFiles[packageRoot] = packageFiles[packageRoot] || [];
            packageFiles[packageRoot].push(entry);
        }
    }
    getPackageFiles(packageName, patterns) {
        const { root, packageInfos } = this.options;
        const packagePath = _path.default.relative(root, _path.default.dirname(packageInfos[packageName].packageJsonPath)).replace(/\\/g, "/");
        const packageFiles = _class_private_field_get(this, _packageFiles)[packagePath];
        if (!packageFiles) {
            return [];
        }
        const key = `${packageName}\0${patterns.join("\0")}`;
        if (!_class_private_field_get(this, _memoizedPackageFiles)[key]) {
            const packagePatterns = patterns.map((pattern)=>{
                if (pattern.startsWith("!")) {
                    return `!${_path.default.join(packagePath, pattern.slice(1)).replace(/\\/g, "/")}`;
                }
                return _path.default.join(packagePath, pattern).replace(/\\/g, "/");
            });
            _class_private_field_get(this, _memoizedPackageFiles)[key] = (0, _micromatch.default)(packageFiles, packagePatterns, {
                dot: true
            });
        }
        return _class_private_field_get(this, _memoizedPackageFiles)[key];
    }
    constructor(options){
        _define_property(this, "options", void 0);
        _class_private_field_init(this, _tree, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _packageFiles, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _memoizedPackageFiles, {
            writable: true,
            value: void 0
        });
        this.options = options;
        _class_private_field_set(this, _tree, {
            children: {},
            isPackage: true
        });
        _class_private_field_set(this, _packageFiles, {});
        _class_private_field_set(this, _memoizedPackageFiles, {});
    }
}
